<template>
	<div class="mt-3">
		<hr class="mt-1" />
		<b-form>
			<b-row>
				<b-col lg="12">
					<span class="h5">A CSV file will be attached and a link will be sent</span>
				</b-col>
				<b-col lg="12">
					<p class="mt-3 mb-1">
						<span class="h3">Recipient Email Address</span>
					</p>
					<b-form-group label-for="input-1">
						<b-form-input :state="emailState" v-model="email"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col lg="12">
					<p class="mt-1 mb-1">
						<span class="h3">Subject</span>
					</p>
					<b-form-group label-for="input-1">
						<b-form-input :state="subjectState" v-model="subject"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col lg="12">
					<p class="mt-1 mb-1">
						<span class="h3">Message (optional)</span>
					</p>
					<b-form-group label-for="input-1">
						<b-form-textarea rows="4" v-model="message"></b-form-textarea>
					</b-form-group>
				</b-col>
			</b-row>
			<hr />
			<b-row class="mt-3">
				<b-col xl="6" md="6" sm="6">
					<div class="float-left">
						<base-button type="white" title="Close"  v-on:click="modalClose()">
							Close
						</base-button>
					</div>
				</b-col>
				<b-col xl="6" md="6" sm="6">
					<div class="float-right">
						<base-button type="primary" title="Email Submit"  v-on:click="emailSubmit" :loading="submitLoading">
								Email Submit
						</base-button>
					</div>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>

<script>
let validRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
import reportsDashboardService from "../../common/api-services/reports-dashboard-service";
let reportURL = `${process.env.VUE_APP_CORDOVA_REPORTS_URL}`;
export default {
	name: "Email-Report",
	components: {},
	computed: {
		emailState() {
			return this.email.length > 0 && validRegex.test(this.email);
		},
		subjectState() {
			return this.subject.length > 0;
		},
	},
	props: {
		text: String,
		url: String,
	},
	data() {
		return {
			email: "",
			subject: "",
			message: "",
			submitLoading: false,
		};
	},
	mounted() {
		this.subject = "Database Report - " + this.text;
	},
	methods: {
		modalClose() {
			this.$bvModal.hide("email-report");
		},

		emailSubmit() {
			if (this.emailState && this.subjectState) {
				this.submitLoading = true;
				let url = reportURL + "/report/html/?report=" + this.url;
				let request = `email=${this.email}&subject=${this.subject}&message=${this.message}&url=${url}`;
				reportsDashboardService.emailReport(request).then(res => {
					this.submitLoading = false;
					this.modalClose();
					if (res.data.success === true) {
						this.$toast.success("Successfully Reported")
					} else {
						this.$toast.error("Invalid")
					}
				});
			}
		},
	},
};
</script>
